import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import uuid from 'node-uuid';
import { FileParser } from 'csv-file-parser-lib';
import { get } from 'lodash';
import { BrandedPanel } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { contentPropTypes } from '../../managePayee/components/managePayeeList/managePayeeList.content'; // Arbitrary tests, not based on requirements
import { addNotification, clearNotification } from '../../states/notifications/actions';
import { getPage } from '../../states/page/selectors';
import { setBackPage, goToImportPayeesPage } from '../../states/page/actions';
import { getAllNotifications } from '../../../src/states/notifications/selectors';
import { getDataIntoObject, getContentKey, getBeneficiaryRules } from '../../utils/benImportUtils';
import { CONST_FILE_UPLOAD } from '../../config/constants';

const mapState = (state) => ({
	currentPage: getPage(state),
	notification: getAllNotifications(state),
});

const mapDispatch = (dispatch) => ({
	addNotification: (key, params) => dispatch(addNotification(key, params)),
	clearNotification: (id) => dispatch(clearNotification(id)),
	goToImportPayeesPage: (importedPayeesList) => dispatch(goToImportPayeesPage(importedPayeesList)),
	setBackPage: (currentPage) => dispatch(setBackPage(currentPage)),
});

export const FileImport = ({
	content,
	addNotification,
	goToImportPayeesPage,
	currentPage,
	setBackPage,
	notification,
	clearNotification,
	faq,
	template,
	maxRecords,
}) => {
	const onParseComplete = (results) => {
		const importedPayeesList = results.map(([name, display_name, sort_code, account_number, reference]) => ({
			id: uuid.v4(),
			name,
			display_name,
			sort_code,
			account_number,
			reference,
		}));
		const notificationId = get(notification, '[0].id', 0);
		if (notificationId) clearNotification(notificationId);
		setBackPage(currentPage);
		goToImportPayeesPage(importedPayeesList);
	};
	const onError = (error) => {
		window.scrollTo(0, 0);
		const formattedData = [];
		if (error.rowData && error.rowData.length > 0) {
			formattedData.push(getDataIntoObject(error.rowData));
		}
		const notificationId = get(notification, '[0].id', 0);
		if (notificationId) clearNotification(notificationId);
		const {
			CLIENT_SIDE_ERROR: { EMPTY_FILE, DEFAULT },
		} = CONST_FILE_UPLOAD;
		const frontEndErrorType = error.length === 0 ? EMPTY_FILE : DEFAULT;
		addNotification(frontEndErrorType, {
			formattedData,
			contentKey: getContentKey(error.type),
			errorType: error.type,
			isServerValidation: false,
			maxRecordsLimit: maxRecords,
		});
	};
	const { fileImportText, fileImportHeader, instructionsURLText, templateURLText } = content;
	const { isHeaderRow, rules } = getBeneficiaryRules();
	return (
		<BrandedPanel title={fileImportHeader} iconType="Upload">
			<StandardBody>
				<p>{fileImportText.replace('{maxRecords}', maxRecords)}</p>
			</StandardBody>
			<FileParser
				id="file-parser"
				isHeaderRow={isHeaderRow}
				minRecords={1}
				maxRecords={maxRecords}
				rules={rules}
				onComplete={onParseComplete}
				onError={onError}
				submitOnSelect
				ignoreEmpty
				ignoreExtraColumns
			/>
			<WebsiteLink url={faq} linkText={instructionsURLText} willOpenNewWindow />
			<WebsiteLink url={template} linkText={templateURLText} willOpenNewWindow />
		</BrandedPanel>
	);
};

FileImport.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	addNotification: PropTypes.func.isRequired,
	goToImportPayeesPage: PropTypes.func.isRequired,
	currentPage: PropTypes.string.isRequired,
	setBackPage: PropTypes.func.isRequired,
	clearNotification: PropTypes.func.isRequired,
	notification: PropTypes.arrayOf(PropTypes.string.isRequired),
	faq: PropTypes.string.isRequired,
	template: PropTypes.string.isRequired,
	maxRecords: PropTypes.number.isRequired,
};

export default connect(mapState, mapDispatch)(FileImport);
